import * as React from 'reactn';
import {ArrayUtil, BaseIcon, ComponentFactory, dialog, IBaseDialogProps} from "oca-lib-web";
import SelectionDialog from "./SelectionDialog";
import {createRef} from "react";
import Styles from "../style/Styles";
import DataMappingUtil from 'src/util/DataMappingUtil';
import CacheSettings from 'src/util/CacheSettings';

interface IState {
    componentFactory:ComponentFactory,
    dialogs:Array<any>,
    dataMappings: Array<DataMapping>
}

class GraphFilterDialog extends React.Component<IBaseDialogProps, IState> {

    public filterSelectionDialog = createRef<any>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, props.param);

        let dialogs = [
            <SelectionDialog {...componentFactory.renderDialogProps("Filter Selection", "Save", this.filterSelectionDialogCallback.bind(this), this.filterSelectionDialog)} />,
        ];

        this.state = {
            componentFactory:componentFactory,
            dialogs:dialogs,
            dataMappings:[]
        };

        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    async componentWillMount() {
        var projectId = CacheSettings.getCurrentProject();
        let dataMappings = await DataMappingUtil.getDataMappings(projectId);
        this.setState({dataMappings:dataMappings});
    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        console.log(componentBinding.item);
        callback(componentBinding.item);
    }

    filterSelectionDialogCallback(graphSelection:GraphSelection) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        let filters = componentBinding.getProperty("filters") || [];
        filters.push(graphSelection);
        this.state.componentFactory.getDefaultBinding().setProperty("filters", filters);
        this.forceUpdate();
    }

    deleteSelectionCallback(item:GraphSelection) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        ArrayUtil.deleteItem(item, componentBinding.item.filters);
        this.forceUpdate();
        //self.setState({graphSettings: graphSettings});
    }

    // Render Methods

    public renderFilterRow(item:GraphSelection) {
        let deleteFunction = () => this.props.dialog.alert("Confirm Delete", "Are you sure you want to delete this graph? This action cannot be undone.", this.deleteSelectionCallback.bind(this), item);
        let selectionValues = item.isCustom ? item.selectionValuesCustom : item.selectionValues;

        return [
            DataMappingUtil.replaceData(item.selectionName, this.state.dataMappings),
            DataMappingUtil.replaceData(selectionValues, this.state.dataMappings),
            this.state.componentFactory.renderIconButton(BaseIcon.ICON_DELETE, deleteFunction, "Delete", {color:"secondary"})
        ];
    }

    public render() {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        let cf = this.state.componentFactory;
        return (
            cf.renderBox([
                this.state.dialogs,
                cf.renderTableWithNew(["Filter Name", "Filter Values", ""], componentBinding.getProperty("filters"), this.renderFilterRow.bind(this),
                    this.filterSelectionDialog, {graphSettings:componentBinding.item})
            ])
        )
    }
}

export default dialog(GraphFilterDialog)